module.exports = __webpack_public_path__ + "img/375.87464eaf.jpg";